import { memo } from "react";
import { FeatureCollection } from "geojson";
import { useFilters } from "core/features/filters/store";
import { useFiltersLists } from "core/features/filters/store/lists";
import { TipoMapaTalhoes } from "core/features/maps/typings";
import { useRainfallInterpolationOverlay } from "../../hooks/useRainfallInterpolationOverlay";

interface RainfallInterpolationLayerProps {
  map: google.maps.Map | null | undefined;
  points?: FeatureCollection & {
    Properties?: {
      latitudeMinima?: number;
      latitudeMaxima?: number;
      longitudeMinima?: number;
      longitudeMaxima?: number;
    };
  };
}

function RainfallInterpolationLayerComponent({
  map,
  points,
}: RainfallInterpolationLayerProps) {
  const {
    filters: { tipoMapa, filtroMapaDeChuva },
  } = useFilters();
  const { mapaDeChuvas } = useFiltersLists();

  useRainfallInterpolationOverlay({
    map,
    enabled: tipoMapa === TipoMapaTalhoes.Chuvas,
    points,
    indices: mapaDeChuvas?.indices,
    selectedBandCodes: filtroMapaDeChuva?.indicesPluviometrico,
  });

  return null;
}

export const RainfallInterpolationLayer = memo(
  RainfallInterpolationLayerComponent
);

export default RainfallInterpolationLayer;
